import * as store from '../data/store.js' 

export function createGetHeaders({
    authenticationToken = '',
} = {}) {
    const headers = new Headers()


    headers.append('Accept', 'application/json, text/javascript, */*; q=0.01')
    headers.append('Content-Type', 'application/json; charset=utf-8')

    if (authenticationToken !== '' || authenticationToken !== null)
        headers.append('Authorization', 'Bearer ' + authenticationToken)
        //headers.append('With-Credentials', true)

    return headers
}

export async function getAFetch({
    includeAuthorization = false,
    endpoint,
    parameters = {},
} = {}) {
    const url = new URL(endpoint)
    console.info({includeAuthorization})

    url.search = new URLSearchParams(parameters).toString()
    
    const authToken = includeAuthorization ? store.getAuthentication().token  : null

    try {
    const response = await fetch(url, {
        method: 'GET',
        headers: createGetHeaders({
            includeAuthorization,
            authenticationToken: authToken,
        }),
    })

    if (!response.ok) {
        console.info(response)
        throw new Error(
            `HTTP ${response.status} - There is a problem connecting to the web service.`
        )
    }

    const json = await response.json()

    console.info({ json })

    return json

    } catch (e) {
        console.info({ e })
        return {
            hasError: true,
            errorMessage: 'hmmm',
        }
    }

    
}
